import React from 'react';
import './Twoplateni.css';
import twoPlatenVideo from '../../../video/PlatenMoldin.mp4';
import Reqprodcte from "../../../components/Reqprodcte"; 


const Twoplateni = () => {
  return (
    <div className="video-banner">
      <video autoPlay muted loop className="background-video">
        <source src={twoPlatenVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay">
        <h1>Disha Two Platen</h1>
        <h2>Injection Molding Machine</h2>
        <p>A Long-term Investment in Reliability</p>
        <p>
          Our Two Platen Injection Molding Machines with innovative Fixed Tie-bar
          system and independent oil cylinders enhance durability and offer a distinct
          advantage in lowering maintenance costs.
        </p>
        <p>Choose Powerjet for a dependable, long-term solution to your manufacturing needs.</p>
     <div className='stnd'>
                            <Reqprodcte />
                        </div>
      </div>
    </div>
  );
};

export default Twoplateni;
